<template>
	<Modal
		v-if="isVisible"
		:size="size"
		:class="{'is-loading' : isLoading}"
		@close="onClose"
	>
		<template slot="header">
			<h3>Disconnect account {{ marketplaceName }}</h3>
		</template>

		<template slot="body">
			<p>
				Are you sure you want to disconnect
				<strong>{{ shopLabel }}</strong>?
			</p>
			<p class="text-muted small">
				This action will remove the connection to your {{ marketplaceName }} account.
				You can reconnect it anytime.
			</p>
		</template>

		<template slot="footer">
			<button
				type="button"
				class="btn btn-secondary"
				@click="onClose"
				:disabled="isLoading"
			>
				Cancel
			</button>
			<button
				type="button"
				class="btn btn-danger"
				:class="{'is-loading' : isLoading}"
				@click="onConfirm"
				:disabled="isLoading"
			>
				Disconnect
			</button>
		</template>
	</Modal>
</template>

<script>
/* eslint-disable */
import Modal from '@/components/Modal.vue';

export default {
	name: 'ConfirmDisconnectModal',
	components: {
		Modal,
	},
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
		marketplaceName: {
			type: String,
			default: 'Marketplace',
		},
		shopLabel: {
			type: String,
			default: '',
		},
		size: {
			type: String,
			default: 'medium', // small, medium, large
		},
	},
	computed: {
		isVisible: {
			get() {
				return this.visible;
			},
			set(value) {
				this.$emit('update:visible', value);
			}
		}
	},
	methods: {
		onClose() {
			this.$emit('close');
		},
		onConfirm() {
			this.$emit('confirm');
		}
	}
};
</script>
